/**
 * Check if bypass login is enable
 * @warn development only
 */
export const hasBypassLogin = process.env.BYPASS_LOGIN === `${true}` && process.env.NODE_ENV !== 'production';
